export const AUTH_TOKEN_COOKIE = "access_token";
export const FALLBACK_TOKEN_COOKIES = ["jwt_token", "workspace_token"] as const;
export const USER_STORAGE_KEY = "hub_web:user";
export const LAYOUT_STORAGE_KEY = "hub_web:layout";
export const USERS_TABLE_DENSITY_KEY = "hub_web:users-table-density";
export const AUDIT_TABLE_DENSITY_KEY = "hub_web:audit-table-density";
export const EMBARCACOES_TABLE_DENSITY_KEY = "hub_web:embarcacoes-table-density";
